import { render, staticRenderFns } from "./MenuBars.vue?vue&type=template&id=2c7f6fd5&"
import script from "./MenuBars.vue?vue&type=script&lang=ts&"
export * from "./MenuBars.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports